/*
 * @Author: your name
 * @Date: 2021-04-30 15:58:02
 * @LastEditTime: 2021-05-12 15:36:19
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \new_if_admind:\phpstudy_pro\WWW\lfadmin\src\mixins\select.js
 */

import { requestGet } from '@/api/api'
/**
 * select.js
 * 下拉列表函数
 * @jdy
 * @2021-4-16
 */
const list = {
    data () {
        return {
        }
    },
    methods: {
        /**
         * @Author: JDY
         * @Date: 2021-04-22 13:52:56
         * @LastEditTime: Do not edit
         * @LastEditors: JDY
         * @Description:获取下拉列表
         * @param  {*}
         * @return {*}
         */
        getSelectLists (opt) {
            const defaultOption = {
                url: '',
                params: {},
                type: 'selectList',
                load: 'selectLoading',
                arr: null
            }
            const option = Object.assign(defaultOption, opt)
            this[option.load] = true
            requestGet(option.url, option.params)
                .then(res => {
                    this[option.type] = option.arr ? option.arr.concat(res.result) : res.result
                })
                .finally(() => {
                    this[option.load] = false // 下拉分类加载
                })
        },
        /**
         * 课程证书套购选择全部其他禁止选择
         * @jdy
         * value,name
         * @2020-12-1
         */
        handleSelectChange (value, opt, extra) {
            const defaultOption = {
                name: 'selectList',
                isSearch: true
            }
            const option = Object.assign(defaultOption, opt)
            const [...List] = this[option.name]
            value = value.toString()
            if (value === 'all') {
                List.filter(item => {
                    if (item.id !== 'all') {
                        item.disabled = true
                    }
                })
            } else if (value !== '') {
                List.filter(item => {
                    if (item.id === 'all') {
                        item.disabled = true
                    }
                })
            } else {
                List.filter(item => {
                    item.disabled = false
                })
            }
            if (option.isSearch) {
                this.getLists(extra)
            }
        }
    }

}
export default list
